import Request from "../lib/request";

const baseUrl = process.env.REACT_APP_API_URL;

export const get = () => {
    return Request({
        method: "get",
        url: baseUrl + "/currencies",
        needToken: true
    });
};